import template from './toggle-select-field.html';

const SelectFieldComponent = {
    bindings: {
        displayProp: '<',
        hideLabel: '<',
        inputClass: '<',
        isToggleOn: '<',
        itemList: '<',
        label: '<',
        labelClass: '<',
        onToggle: '&',
        selectedItem: '<',
        setItem: '&'
    },
    template
};

export default SelectFieldComponent;



// WEBPACK FOOTER //
// ./app/common/form-fields/toggle-select-field/toggle-select-field-component.js